import { render } from "./pageItemView.vue?vue&type=template&id=219d7aee&ts=true"
import script from "./pageItemView.vue?vue&type=script&lang=ts"
export * from "./pageItemView.vue?vue&type=script&lang=ts"

import exportComponent from "E:\\Work\\Sales point\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__